// 자산
export const GET_JASAN_LIST = 'GET_JASAN_LIST'
export const GET_JASAN_SCRAP = 'GET_JASAN_SCRAP'
export const GET_JASAN_ALL = 'GET_JASAN_ALL'
export const GET_HIDDEN_ALL = 'GET_HIDDEN_ALL'
export const GET_DELETE_ALL = 'GET_DELETE_ALL'

export const INIT_REGIST_JASAN = 'INIT_REGIST_JASAN'

export const GET_SCRAP_INFOS = 'GET_SCRAP_INFOS'
export const SELECTED_CERT = 'SELECTED_CERT'
export const SELECTED_JASAN = 'SELECTED_JASAN'
export const SELECTED_ACCOUNT = 'SELECTED_ACCOUNT'
export const REGIST_JASAN = 'REGIST_JASAN'
export const REGIST_JASAN_END = 'REGIST_JASAN_END'
export const JASAN_HIDE = 'JASAN_HIDE'
export const JASAN_USEYN = 'JASAN_USEYN'
//    export const UPDATE_JASAN_HIDE_END = 'UPDATE_JASAN_HIDE_END'
export const DELETE_JASAN = 'DELETE_JASAN'
//    export const DELETE_JASAN_END = 'DELETE_JASAN_END'
export const CHANGE_CERT = 'CHANGE_CERT'
export const CHANGE_CERT_END = 'CHANGE_CERT_END'
export const UPDATE_CERTIFY = 'UPDATE_CERTIFY'
export const UPDATE_CERTIFY_END = 'UPDATE_CERTIFY_END'
export const JASAN_ACTION_END = 'JASAN_ACTION_END'
export const TAB_ASSET_MORE = 'TAB_ASSET_MORE'

export const GET_BIZ_NO = 'GET_BIZ_NO'

export const GET_SCRAP_JASAN_INFOS = 'GET_SCRAP_JASAN_INFOS'
export const UNLOAD_SCRAP = 'UNLOAD_SCRAP'


export const LOAD_SCRAP_LAST_DATE = 'LOAD_SCRAP_LAST_DATE'
export const UPDATE_CERTIFY_ON_OFF = 'UPDATE_CERTIFY_ON_OFF'
export const JASAN_SET_UNMOUNT = 'JASAN_SET_UNMOUNT'


// WEBPACK FOOTER //
// ./src/constants/asset.js